<template>
  <div class="checkbox-component">
    <input type="checkbox" @change="$emit('onClick', $event)" v-bind:checked="state" :id="id">
    <slot name="checkbox-text"></slot>
  </div>
</template>

<script type="ts">
import './checkbox.scss';
import {defineComponent} from "vue";

export default defineComponent({
  name: 'CheckBoxComponent',
  emits: ['onClick'],
  props: {
    state: {
      type: Boolean,
      required: false
    },
    id: {
      type: String
    },
  },
  data() {
    return {};
  }
});
</script>

<style lang="scss">
@import "../../../sass/variables";

</style>